import { List, Datagrid, TextField, EmailField, DateField, ShowButton, FunctionField, TextInput } from "react-admin";

const customersFilters = [
  <TextInput source="email" label="EMAIL" alwaysOn variant="standard"/>,
  <TextInput source="phone" label="PHONE" alwaysOn variant="standard"/>,
  <TextInput source="first_name" label="FIRST NAME" variant="standard"/>,
  <TextInput source="last_name" label="LAST NAME" variant="standard"/>,
];

export const AdminList:React.FC = (props: any) => {
  const CustomShowButton = ( record: any) => {
    const path = `${record.resource}/${record.record.id}/show/profiles`;
    return(<ShowButton to={{pathname: path}} record={record}/>);
  };
	
  return(
    <List {...props} filters={customersFilters} sort={{ field: 'created_at', order: 'DESC' }}>
      <Datagrid>
        <TextField source="id" sortable={false} label="ID"/>
        <FunctionField render={(record: any) => `${record.first_name}${record.last_name ? ' ' + record.last_name : ''}`} label="Name"/>
        <EmailField source="email" label="Email"/>
        <TextField source="phone" label="Phone"/>
        <TextField source="points" sortable={false} label="Points"/>
        <DateField source="created_at" label="Joined"/>
        <CustomShowButton />
      </Datagrid>
    </List>
  );
  
};